import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { saveBranding, getBranding } from './branding.api';
import type { SaveBrandingRequest } from '@shared/types/dashboard';

export const useBranding = (shop: string) => {
  return useQuery({
    queryKey: ['branding', shop],
    queryFn: () => getBranding(shop),
    enabled: !!shop,
  });
};

export const useSaveBranding = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: SaveBrandingRequest) => saveBranding(request),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['branding', variables.shop] });
    },
  });
};

